import { useForm } from '../../../../../shared/form/useForm';
import { IGuestBookingFormData } from '../types/IGuestBookingFormData';
import { useGuestBookingSchema } from './useGuestBookingSchema';

export function useGuestBookingForm() {
	const validationSchema = useGuestBookingSchema();
	const form = useForm<IGuestBookingFormData>({
		mode: 'onSubmit',
		validationSchema,
	});

	return form;
}
